import {ReactElement, ReactNode} from 'react';

type Props = {
  children: ReactElement;
  condition: boolean;
  wrapper: (children: ReactNode) => ReactElement;
};

export default function ConditionalWrapper({children, condition, wrapper}: Props): ReactElement {
  return condition ? wrapper(children) : children;
}
